// extracted by mini-css-extract-plugin
export default {"root":"Partition_root__TNfW5","line":"Partition_line__CjqxU"};